import IntakeTextField from "../../../../components/Form/IntakeTextField";
import FieldBlock from "../../../PreActivation/components/FieldBlock";
import FieldHint from "../../../PreActivation/components/FieldHint";
import FieldLabel from "../../../PreActivation/components/FieldLabel";

const NumericFieldBlock = ({
  name,
  labelKey,
  hintKey,
  placeholderKey,
  required = false,
  min = 0,
  control,
  errors,
  readOnly,
  t,
}) => (
  <FieldBlock>
    <FieldLabel htmlFor={name} text={t(labelKey)} required={required} />
    {hintKey ? <FieldHint text={t(hintKey)} /> : null}
    <IntakeTextField
      name={name}
      control={control}
      rules={{}}
      errors={errors}
      fullWidth
      readOnly={readOnly}
      type="number"
      inputProps={{ min, step: 1 }}
      placeholder={placeholderKey ? t(placeholderKey) : undefined}
      variant="outlined"
    />
  </FieldBlock>
);

export default NumericFieldBlock;
